import { AppNavigation } from "@/shared/services/navigation";

/** Define the navigation hierarchy */
export const callTrackingNavigationConfig: AppNavigation = {
  title: "Call tracking",
  icon: "eye_tracking",
  items: [
    {
      title: "Call tracking",
      items: [
        {
          title: "Tracking phone numbers",
          link: "call-tracking-phone-numbers",
          icon: "phone_callback",
        },
        {
          title: "Destination phone numbers",
          link: "call-tracking-destination-phone-numbers",
          icon: "phone_forwarded",
        },
        {
          title: "Tracking pools",
          link: "call-tracking-pools",
          icon: "pool",
        },
      ],
    },
  ],
};
